import difference from 'lodash/difference';
export const getSegmentTravelers = (travelers, flattenedBounds, segmentIndex) => {
  if (!Array.isArray(travelers) || !Array.isArray(flattenedBounds)) {
    return [];
  }
  const segment = flattenedBounds.find(bound => bound.boundSegmentIndex === segmentIndex);
  if (!segment || !segment.travelerIds) {
    return [];
  }
  const travelerIdsSet = new Set(segment.travelerIds.map(id => Number(id)));
  return travelers.filter(({
    id
  }) => travelerIdsSet.has(Number(id)));
};
export const getIdOfFirstUnselectedTraveler = (travelers, selection, currentTravelerId) => {
  if (!Array.isArray(travelers) || travelers.length === 0) {
    return null;
  }
  if (!selection) {
    return travelers[0].id;
  }
  const index = travelers.findIndex(traveler => traveler.id === currentTravelerId);
  const orderedTravelers = index === -1 ? travelers : [...travelers.slice(index), ...travelers.slice(0, index)];
  const nextTraveler = orderedTravelers.find(traveler => selection.every(s => s.id !== traveler.id));
  if (!nextTraveler) {
    return null;
  }
  return nextTraveler.id;
};
export const getSegmentSeatSelections = selectedSeats => Object.entries(selectedSeats).reduce((acc, [key, val]) => {
  if (key === 'selected' || val === null) {
    return acc;
  }
  const travelerIds = Object.values(val).map(traveler => traveler && Number.isInteger(traveler.id) && traveler.id).filter(id => id !== null);
  return [...acc, {
    boundSegmentIndex: key,
    travelerIds
  }];
}, []);
export const getNonSelectedAvailableSegments = (segments = [], totalSelectedSeats) => {
  if (!totalSelectedSeats) {
    return [];
  }
  return segments.reduce((acc, val) => {
    var _currentSelectedSegme, _val$travelerIds;
    if (!val.isAvailable) {
      return acc;
    }
    const currentSelectedSegment = totalSelectedSeats.find(s => s.boundSegmentIndex === val.boundSegmentIndex);
    const selectedTravelerIds = (_currentSelectedSegme = currentSelectedSegment === null || currentSelectedSegment === void 0 ? void 0 : currentSelectedSegment.travelerIds) !== null && _currentSelectedSegme !== void 0 ? _currentSelectedSegme : [];
    const allTravelerIds = (_val$travelerIds = val.travelerIds) === null || _val$travelerIds === void 0 ? void 0 : _val$travelerIds.filter(id => id !== null).map(Number);
    const areAllSeatsSelected = currentSelectedSegment ? difference(allTravelerIds, selectedTravelerIds).length === 0 : false;
    if (areAllSeatsSelected) {
      return acc;
    }
    return [...acc, val];
  }, []);
};
export const getNonBookedTravelerSeats = (segment, totalSelectedSeats) => {
  if (!segment || !segment.travelerIds || segment.travelerIds.length === 0) {
    return [];
  }
  if (!totalSelectedSeats) {
    return segment.travelerIds;
  }
  const currentSelectedSegment = totalSelectedSeats.find(s => s.boundSegmentIndex === segment.boundSegmentIndex);
  if (!currentSelectedSegment) {
    return segment.travelerIds;
  }
  return difference(segment.travelerIds.map(Number), currentSelectedSegment.travelerIds);
};
//# sourceMappingURL=travelerUtils.js.map